module.exports = __webpack_public_path__ + "img/menu_cover.2b40cbe0.png";